import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import { Header } from 'src/app/utils/interfaces/new/header.interface';

@Injectable({
  providedIn: 'root'
})
export class HeaderCommunicationService {

  constructor(
    private _title: Title
  ) {

  }
  // Observable string sources
  private headerAnnounce = new Subject<Header>();
  private headerConfirmed = new Subject<Header>();

  // Observable string streams
  headerAnnounce$ = this.headerAnnounce.asObservable();
  headerConfirmed$ = this.headerConfirmed.asObservable();

  /**
   * Si vous devez appeler cette fonction, veillez à le faire dans le constructeur de votre page
   * pour que cet appel soit fait avant le "ViewChecked" du cycle de vie de l'application.
   * @param head 
   */
  // Service message commands
  announceHeader(head: Header) {
    this.headerAnnounce.next(head);
    this._title.setTitle(head.title ? head.title : 'Hypermed');
  }

  confirmHeader(head: Header) {
    this.headerConfirmed.next(head);
  }
}
